import moment from "moment";

import { DateTimeFilterMatchEnum } from "../models/autogenerated-deliveryService-gql/graphql";
import { ITag, TagName } from "../models/tag";

//this is a list of all existing tags with filterOptions
const tagList: ITag[] = [
  {
    name: TagName.Today,
    inputParameters: {
      plannedDeliveryDateFilter: moment().utc().startOf("day").toDate(),
      plannedDeliveryDateFilterMatch: DateTimeFilterMatchEnum.Equals,
    },
  },
  {
    name: TagName.Tomorrow,
    inputParameters: {
      plannedDeliveryDateFilter: moment()
        .utc()
        .add(1, "days")
        .startOf("day")
        .toDate(),
      plannedDeliveryDateFilterMatch: DateTimeFilterMatchEnum.Equals,
    },
  },
  {
    name: TagName.Future,
    inputParameters: {
      plannedDeliveryDateFilter: moment()
        .utc()
        .add(2, "days")
        .startOf("day")
        .toDate(),
      plannedDeliveryDateFilterMatch:
        DateTimeFilterMatchEnum.GreaterThanOrEquals,
    },
  },
  {
    name: TagName.NotPlanned,
    inputParameters: {
      plannedDeliveryDateFilter: null,
      plannedDeliveryDateFilterMatch: DateTimeFilterMatchEnum.Equals,
    },
  },
  {
    name: TagName.AllDeliveries,
    inputParameters: {
      plannedDeliveryDateFilter: null,
      plannedDeliveryDateFilterMatch: null,
    },
  },
];

//these represent the clickable tagFilters that exist on the deliveryList
const deliveryListTagNames = [
  TagName.Today,
  TagName.Tomorrow,
  TagName.Future,
  TagName.NotPlanned,
];

//these represent the tagFilters that get sent to the backend to get a count for each on the Dashboard
const dashboardTagNames = [
  TagName.Today,
  TagName.Tomorrow,
  TagName.Future,
  TagName.NotPlanned,
  TagName.AllDeliveries,
];

//extracts only the needed tags from the tagList
export const deliveriesListTags = tagList.filter((tag) =>
  deliveryListTagNames.includes(tag.name as TagName),
);

//extracts only the needed tags from the tagList
export const dashboardTags = tagList.filter((tag) =>
  dashboardTagNames.includes(tag.name as TagName),
);
